import actionTypes from "../actionTypes";

const users = (state = [], action) => {
  switch (action.type) {
    case actionTypes.USERS_FETCH:
      return action.payload.data;
    case actionTypes.USER_FETCH:
      if (state.filter(user => action.payload.data.id === user.id).length) {
        return state.map(user => {
          if (user.id === action.payload.data.id) {
            return action.payload.data;
          }
          return user;
        });
      }

      return [...state, action.payload.data];
    default:
      return state;
  }
};

export default users;



// WEBPACK FOOTER //
// ./src/redux/reducers/Users.js